import React, { Component } from 'react';
import { USER, VIDEO } from "../../components/image";
import "../dashboard/dashboard.css";
import ComplatedStoryGraph from "../../components/dashbord/ComplatedStoryGraph";
import ViewsOfStory from "../../components/dashbord/ViewsOfStory";
import SignupGraph from "../../components/dashbord/SignupGraph";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import $ from 'jquery';
window.$ = $;

const storiesViewers = [
  {
    name: "Jack",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.	",
    watchedBy: "Jack",
  },
  {
    name: "Messy",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.	",
    watchedBy: "Messy",
  },
  {
    name: "James",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.	",
    watchedBy: "James",
  },
  {
    name: "Dolly",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.	",
    watchedBy: "Dolly",
  },
  {
    name: "Jonathan",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.	",
    watchedBy: "Jonathan",
  },
  {
    name: "Harry",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.	",
    watchedBy: "Harry",
  },
  {
    name: "Alice",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.	",
    watchedBy: "Alice",
  },

  {
    name: "Bob",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.",
    watchedBy: "Bob",
  },

  {
    name: "Charlie",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.",
    watchedBy: "Charlie",
  },

  {
    name: "Diana",
    title: "Non tempor nostrud nostrud elit esse aliqua culpa aute voluptate.",
    watchedBy: "Diana",
  },
];

const Dashboard = () => {
  return (
    <div className="container1 container">
      <div className="overview">
        <div className="title">
          <ion-icon name="speedometer"></ion-icon>
          <span className="text">Dashboard</span>
        </div>
        <div className="boxes">
          <div className="box box1">
            <ion-icon name="eye-outline"></ion-icon>
            <span className="text">Total Views</span>
            <span className="number">18345</span>
          </div>
          <div className="box box2">
            <ion-icon name="people-outline"></ion-icon>
            <span className="text">Active users</span>
            <span className="number">2745</span>
          </div>
          <div className="box box3">
            <ion-icon name="add-circle-outline"></ion-icon>
            <span className="text">Stories</span>
            <span className="number">1209</span>
          </div>
          <div className="box box4">
            <ion-icon name="chatbubble-outline"></ion-icon>
            <span className="text">Pending Messages</span>
            <span className="number">123</span>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="title">
            <ion-icon name="stats-chart-outline"></ion-icon>
            <span className="text">Sign-ups</span>
          </div>
          <div className="mb-3 complateStory d-flex justify-content-end">
            {/* <select className='form-select selectfilter selectfilterSignup'>
              <option style={{ background: 'white' }}>Total Number</option>
              <option style={{ background: 'white' }}>Jordan</option>
              <option style={{ background: 'white' }}>Palestine</option>
              <option style={{ background: 'white' }}>Israel</option>
            </select> */}
            <DateRangePicker initialSettings={{ startDate: '1/1/2014', endDate: '3/1/2014' }}>
              <button className='selectDateRange'>Select Date Range</button>
            </DateRangePicker>
          </div>
          <SignupGraph />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="title">
            <ion-icon name="stats-chart-outline"></ion-icon>
            <span className="text">Completed Stories</span>
          </div>
          <div className="mb-3 complateStory d-flex justify-content-end">
            {/* <select className='form-select selectfilter selectfilterSignup'>
              <option style={{ background: 'white' }}>Total Number</option>
              <option style={{ background: 'white' }}>Jordan</option>
              <option style={{ background: 'white' }}>Palestine</option>
              <option style={{ background: 'white' }}>Israel</option>
            </select> */}
            <DateRangePicker initialSettings={{ startDate: '1/1/2014', endDate: '3/1/2014' }}>
              <button className='selectDateRange'>Select Date Range</button>
            </DateRangePicker>
          </div>
          <ComplatedStoryGraph />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="title">
            <ion-icon name="stats-chart-outline"></ion-icon>
            <span className="text">Views of Story 1L</span>
          </div>
          <div className="mb-3 complateStory d-flex justify-content-end">
            {/* <select className='form-select selectfilter selectfilterSignup'>
              <option style={{ background: 'white' }}>Total Number</option>
              <option style={{ background: 'white' }}>Jordan</option>
              <option style={{ background: 'white' }}>Palestine</option>
              <option style={{ background: 'white' }}>Israel</option>
            </select> */}
            <DateRangePicker initialSettings={{ startDate: '1/1/2014', endDate: '3/1/2014' }}>
              <button className='selectDateRange'>Select Date Range</button>
            </DateRangePicker>
          </div>
          <ViewsOfStory />
        </div>
      </div>

      {/* <div className="row">
        <div className="col-md-6 p-3">
          <div className="title">
            <ion-icon name="stats-chart-outline"></ion-icon>
            <span className="text">Completed Stories</span>
          </div>
          <div className=" mb-3 complateStory d-flex justify-content-end">
            <select className='form-select selectfilter'>
              <option style={{ background: 'white' }}>Total Number</option>
              <option style={{ background: 'white' }}>Jordan</option>
              <option style={{ background: 'white' }}>Palestine</option>
              <option style={{ background: 'white' }}>Israel</option>
            </select>
            <DateRangePicker initialSettings={{ startDate: '1/1/2014', endDate: '3/1/2014' }}>
              <button className='complateStory selectDateRange'>Select Date Range</button>
            </DateRangePicker>
          </div>
          <ComplatedStoryGraph />
        </div>
        <div className="col-md-6 p-3">
          <div className="title">
            <ion-icon name="stats-chart-outline"></ion-icon>
            <span className="text">Views of Story 1L</span>
          </div>
          <div className="mb-3 complateStory d-flex justify-content-end">
            <select className='form-select selectfilter'>
              <option style={{ background: 'white' }}>Total Number</option>
              <option style={{ background: 'white' }}>Jordan</option>
              <option style={{ background: 'white' }}>Palestine</option>
              <option style={{ background: 'white' }}>Israel</option>
            </select>
            <DateRangePicker initialSettings={{ startDate: '1/1/2014', endDate: '3/1/2014' }}>
              <button className='selectDateRange'>Select Date Range</button>
            </DateRangePicker>
          </div>
          <ViewsOfStory />
        </div>
      </div> */}

      {/* <div className="data-table activityTable mb-5">
        <div className="title">
          <ion-icon name="time-outline"></ion-icon>
          <span className="text">Recent Stories View</span>
        </div>
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>User</th>
                <th>Title</th>
                <th>Thumbnail</th>
                <th>Watched By</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {storiesViewers.map((storyViewer, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="user">{storyViewer.name}</div>
                  </td>
                  <td>{storyViewer.title}</td>
                  <td>
                    <img src={VIDEO} className="image" alt="thumbnail" />
                  </td>
                  <td>{storyViewer.watchedBy}</td>
                  <td>View</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
    </div>
  );
};

export default Dashboard;
